module.exports = __webpack_public_path__ + "static/media/restaurant-cook.ffbd5f37.jpg";